module.exports = __webpack_public_path__ + "img/logowhite.4debd5c5.png";